import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import client, { endpoints, errText } from '../../api/client';
import StatusBadge from '../../components/StatusBadge';
import { money, dt } from '../../lib/format';

const STATUSES = ['new', 'consult_scheduled', 'scoped', 'sent', 'accepted', 'declined', 'expired'];

export default function Quotes() {
  const [params, setParams] = useSearchParams();
  const [data, setData] = useState({ items: [], total: 0 });
  const [err, setErr] = useState('');
  const status = params.get('status') || '';

  useEffect(() => {
    client.get(endpoints.quotes.list, { params: { status: status || undefined, limit: 100 } })
      .then((r) => setData(r.data))
      .catch((e) => setErr(errText(e)));
  }, [status]);

  return (
    <section className="section">
      <div className="section-head"><h1>Quote requests <span className="muted">({data.total})</span></h1></div>
      <div className="filters">
        <label>Status
          <select value={status} onChange={(e) => {
            const next = new URLSearchParams(params);
            if (e.target.value) next.set('status', e.target.value); else next.delete('status');
            setParams(next);
          }}>
            <option value="">All</option>
            {STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}
          </select>
        </label>
      </div>

      {err && <p className="alert alert-err">{err}</p>}
      {data.items.length === 0 && !err && <p className="muted">No quote requests yet.</p>}

      {data.items.length > 0 && (
        <table className="table">
          <thead><tr><th>Received</th><th>Reference</th><th>Client</th><th>City</th><th>Job</th><th>Status</th><th>Value</th></tr></thead>
          <tbody>
            {data.items.map((q) => (
              <tr key={q._id}>
                <td>{dt(q.createdAt)}</td>
                <td><Link to={`/ops/quotes/${q.reference}`}>{q.reference}</Link></td>
                <td>{q.company || q.contact?.name}<div className="muted small">{q.contact?.name} · {q.contact?.phone}</div></td>
                <td>{q.city || <span className="muted">—</span>}</td>
                <td>{q.propertyType || '—'}{q.sizeSqm ? ` · ${q.sizeSqm} sqm` : ''}{q.units ? ` · ${q.units} units` : ''}
                  {q.recurringInterest && <div className="muted small">wants a recurring plan</div>}</td>
                <td><StatusBadge status={q.status} kind="quote" /></td>
                <td>{q.totalMinor ? money(q.totalMinor, q.currency) : <span className="muted">not priced</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
